/**
 * CV Form Validation Utilities
 */

import { CVFormData } from '../types/cv.types';

export const validateTCKN = (tckn: string): boolean => {
  if (!tckn || tckn.length !== 11) return false;
  
  const digits = tckn.split('').map(Number);
  if (digits[0] === 0) return false;
  
  // 10. hane kontrolü
  const sum10 = (digits[0] + digits[2] + digits[4] + digits[6] + digits[8]) * 7 -
                (digits[1] + digits[3] + digits[5] + digits[7]);
  if (sum10 % 10 !== digits[9]) return false;
  
  // 11. hane kontrolü
  const sum11 = digits.slice(0, 10).reduce((a, b) => a + b, 0);
  if (sum11 % 10 !== digits[10]) return false;
  
  return true;
};

export const validatePhone = (phone: string): boolean => {
  // Türkiye telefon numarası formatı
  const phoneRegex = /^(05\d{9}|5\d{9}|0\d{10})$/;
  return phoneRegex.test(phone.replace(/[\s-()]/g, ''));
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateCV = (formData: CVFormData): { isValid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};

  // Personal Info validation
  if (!formData.personalInfo.firstName?.trim()) {
    errors['personalInfo.firstName'] = 'Ad alanı zorunludur';
  }

  if (!formData.personalInfo.lastName?.trim()) {
    errors['personalInfo.lastName'] = 'Soyad alanı zorunludur';
  }

  if (!formData.personalInfo.tckn) {
    errors['personalInfo.tckn'] = 'TC Kimlik No zorunludur';
  } else if (!validateTCKN(formData.personalInfo.tckn)) {
    errors['personalInfo.tckn'] = 'Geçerli bir TC Kimlik No giriniz';
  }

  if (!formData.personalInfo.birthDate) {
    errors['personalInfo.birthDate'] = 'Doğum tarihi zorunludur';
  }

  if (!formData.personalInfo.phone) {
    errors['personalInfo.phone'] = 'Telefon numarası zorunludur';
  } else if (!validatePhone(formData.personalInfo.phone)) {
    errors['personalInfo.phone'] = 'Geçerli bir telefon numarası giriniz';
  }

  if (!formData.personalInfo.email) {
    errors['personalInfo.email'] = 'E-posta adresi zorunludur';
  } else if (!validateEmail(formData.personalInfo.email)) {
    errors['personalInfo.email'] = 'Geçerli bir e-posta adresi giriniz';
  }

  // KVKK Consent validation
  if (!formData.kvkkConsent) {
    errors['kvkkConsent'] = 'KVKK aydınlatma metnini kabul etmelisiniz';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export default {
  validateCV,
  validateTCKN,
  validatePhone,
  validateEmail
};
